import { Layout } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useRequest from "../../hooks/useRequest";
import { Severty, ShowToast } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import { Container } from "react-bootstrap";

function Footer() {
  const { Footer: AntFooter } = Layout;
  const location = useLocation();
  const [contentPages, setContentPages] = useState([]);
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

 

  return (
    <>
      <Container fluid>
        <section className="copyright-section">
          <div className="copyright-label">
            <h4>© 2025 Final Round</h4>
            <div className="terms-and-screen">
              <Link to="/terms-and-condition">Terms of Service</Link>
              <Link to="/privecy-policy">Privacy Policy</Link>
            </div>
          </div>
        </section>
      </Container>
    </>
  );
}

export default Footer;
